export default function equals (a, b) {
  if (a === b) return true
  if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime()
  if (!a || !b || (typeof a !== 'object' && typeof b !== 'object')) return a === b
  if (a === null || a === undefined || b === null || b === undefined) return false
  if (a.prototype !== b.prototype) return false
  const keys = Object.keys(a)
  if (keys.length !== Object.keys(b).length) return false
  return keys.every((k) => {
    // a key that exists on only one side would crash the comparison below
    if (a[k] === undefined || b[k] === undefined) return a[k] === b[k]
    return equals(JSON.parse(JSON.stringify(a[k])), JSON.parse(JSON.stringify(b[k])))
  })
}
